export type NamedEnv = 'dev' | 'stg' | 'live'
export const NAMED_ENVS = ['dev', 'stg', 'live'] as const
export const isNamedEnv = (value: string): value is NamedEnv =>
  (NAMED_ENVS as readonly string[]).includes(value)
export const getValidSecondaryEnv = (value: string | null): NamedEnv =>
  value === 'stg' || value === 'live' ? value : 'dev'
